import Icon from '@ant-design/icons';
import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import FullScreenSvg from '@/components/Icon/svgs/arrows-pointing-in.svg';
import SmallScreenSvg from '@/components/Icon/svgs/arrows-pointing-out.svg';
import useGeniusLayout from '@/hooks/useGeniusLayout';
import { EVENT } from '@/utils/event';
import reportClick, { EReportClickKey } from '@/utils/report/reportClick';

import styles from './index.less';

export interface IProps extends HTMLAttributes<HTMLDivElement> {
  hideVoiceIcon?: boolean;
}

export default function FullScreenIcon(): JSX.Element {
  const { chatStatus } = useGeniusLayout();

  return (
    <div
      className={classNames(styles.buttonItem, { [styles.onlyIcon]: true })}
      id="fullScreen"
      onClick={() => {
        reportClick(EReportClickKey.clicked_full_screen);
        dispatchEvent(new CustomEvent(EVENT.CHANGE_CHAT_STATUS_LAYOUT, { detail: 'fullScreen' }));
      }}
    >
      <Icon
        className={styles.icon}
        component={chatStatus === 'fullScreen' ? FullScreenSvg : SmallScreenSvg}
      />
    </div>
  );
}
